var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container-fluid mt-4"
  }, [_c("b-row", {
    staticClass: "d-none d-lg-flex"
  }, [_c("b-col", {
    attrs: {
      cols: "12",
      lg: "6"
    }
  }, [_c("div", {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c("h4", {
    staticClass: "mb-0"
  }, [_vm._v("Articles du Café")]), _vm._v(" "), _c("div", {
    staticClass: "d-flex align-items-center"
  }, [_c("b-form-input", {
    staticClass: "mr-2",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      placeholder: "Rechercher...",
      size: "sm"
    },
    model: {
      value: _vm.searchQuery,
      callback: function ($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), _c("b-button", {
    attrs: {
      variant: "primary",
      size: "sm"
    },
    on: {
      click: _vm.promptAddItem
    }
  }, [_c("i", {
    staticClass: "fas fa-plus mr-1"
  }), _vm._v(" Ajouter un article\n          ")])], 1)]), _vm._v(" "), _c("b-card", [_c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.filteredItems,
      "primary-key": "item_id",
      hover: "",
      responsive: "",
      small: "",
      "head-variant": "light"
    },
    on: {
      "row-clicked": _vm.selectItem
    },
    scopedSlots: _vm._u([{
      key: "cell(item_price)",
      fn: function (data) {
        return [_c("span", [_vm._v(_vm._s(_vm.formatPrice(data.item.item_price)))])];
      }
    }, {
      key: "cell(actions)",
      fn: function (row) {
        return [_c("b-button", {
          staticClass: "mr-2",
          attrs: {
            size: "sm",
            variant: "danger"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return _vm.deleteItem(row.item);
            }
          }
        }, [_c("i", {
          staticClass: "fas fa-trash-alt"
        })])];
      }
    }])
  })], 1)], 1), _vm._v(" "), _c("b-col", {
    attrs: {
      cols: "12",
      lg: "6"
    }
  }, [_c("div", {
    staticClass: "sticky-col",
    staticStyle: {
      position: "sticky",
      top: "0",
      "max-height": "100vh",
      overflow: "auto",
      "padding-bottom": "1rem"
    }
  }, [_vm.selectedItem ? _c("b-card", {
    staticClass: "h-100 d-flex flex-column"
  }, [_c("h5", {
    staticClass: "mb-3"
  }, [_vm._v("Détails de l'article")]), _vm._v(" "), _c("b-form", {
    on: {
      submit: function ($event) {
        $event.preventDefault();
        return _vm.updateSelectedItem.apply(null, arguments);
      }
    }
  }, [_c("b-form-group", {
    attrs: {
      label: "Nom",
      "label-cols": "3"
    }
  }, [_c("b-form-input", {
    attrs: {
      required: ""
    },
    model: {
      value: _vm.selectedItemCopy.item_name,
      callback: function ($$v) {
        _vm.$set(_vm.selectedItemCopy, "item_name", $$v);
      },
      expression: "selectedItemCopy.item_name"
    }
  })], 1), _vm._v(" "), _c("b-form-group", {
    attrs: {
      label: "Catégorie",
      "label-cols": "3"
    }
  }, [_c("v-select", {
    attrs: {
      options: _vm.categories,
      taggable: "",
      placeholder: "Sélectionner ou ajouter une catégorie"
    },
    model: {
      value: _vm.selectedItemCopy.item_cat,
      callback: function ($$v) {
        _vm.$set(_vm.selectedItemCopy, "item_cat", $$v);
      },
      expression: "selectedItemCopy.item_cat"
    }
  })], 1), _vm._v(" "), _c("b-form-group", {
    attrs: {
      label: "Prix",
      "label-cols": "3"
    }
  }, [_c("b-form-input", {
    attrs: {
      type: "number",
      step: "0.01",
      required: ""
    },
    model: {
      value: _vm.selectedItemCopy.item_price,
      callback: function ($$v) {
        _vm.$set(_vm.selectedItemCopy, "item_price", _vm._n($$v));
      },
      expression: "selectedItemCopy.item_price"
    }
  })], 1), _vm._v(" "), _c("b-form-group", {
    attrs: {
      label: "Image",
      "label-cols": "3"
    }
  }, [_c("div", {
    staticClass: "mb-2"
  }, [_vm.selectedItemPreviewImage ? _c("img", {
    staticClass: "d-block mb-2 border rounded",
    staticStyle: {
      "max-width": "150px",
      "max-height": "150px"
    },
    attrs: {
      src: _vm.selectedItemPreviewImage,
      alt: "Preview Image"
    }
  }) : _vm.selectedItemImage ? _c("img", {
    staticClass: "d-block mb-2 border rounded",
    staticStyle: {
      "max-width": "150px",
      "max-height": "150px"
    },
    attrs: {
      src: _vm.selectedItemImage,
      alt: "Item Image"
    }
  }) : _vm._e()]), _vm._v(" "), _c("b-form-file", {
    attrs: {
      accept: "image/*"
    },
    on: {
      change: _vm.onDetailImageSelected
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "mt-3 d-flex justify-content-between"
  }, [_c("div", [_c("b-button", {
    attrs: {
      variant: "danger"
    },
    on: {
      click: _vm.deleteSelectedItem
    }
  }, [_c("i", {
    staticClass: "fas fa-trash-alt"
  }), _vm._v(" Supprimer\n                ")])], 1), _vm._v(" "), _c("div", [_c("b-button", {
    staticClass: "mr-2",
    attrs: {
      variant: "success",
      type: "submit"
    }
  }, [_vm._v("Modifier")]), _vm._v(" "), _c("b-button", {
    attrs: {
      variant: "secondary"
    },
    on: {
      click: _vm.resetSelection
    }
  }, [_vm._v("Annuler")])], 1)])], 1)], 1) : _c("div", {
    staticClass: "h-100 d-flex align-items-center justify-content-center flex-column text-muted"
  }, [_c("p", [_vm._v("Aucun article sélectionné.")]), _vm._v(" "), _c("p", [_vm._v("Veuillez sélectionner un article dans la liste pour afficher ses détails.")])])], 1)])], 1), _vm._v(" "), _c("div", {
    staticClass: "d-block d-lg-none"
  }, [!_vm.selectedItem ? _c("div", [_c("div", {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c("h4", {
    staticClass: "mb-0"
  }, [_vm._v("Articles du Café")]), _vm._v(" "), _c("div", {
    staticClass: "d-flex align-items-center"
  }, [_c("b-form-input", {
    staticClass: "mr-2",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      placeholder: "Rechercher...",
      size: "sm"
    },
    model: {
      value: _vm.searchQuery,
      callback: function ($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), _c("b-button", {
    attrs: {
      variant: "primary",
      size: "sm"
    },
    on: {
      click: _vm.promptAddItem
    }
  }, [_c("i", {
    staticClass: "fas fa-plus mr-1"
  }), _vm._v(" Ajouter\n          ")])], 1)]), _vm._v(" "), _c("b-card", [_c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.filteredItems,
      "primary-key": "item_id",
      hover: "",
      responsive: "",
      small: "",
      "head-variant": "light"
    },
    on: {
      "row-clicked": _vm.selectItem
    },
    scopedSlots: _vm._u([{
      key: "cell(item_price)",
      fn: function (data) {
        return [_c("span", [_vm._v(_vm._s(_vm.formatPrice(data.item.item_price)))])];
      }
    }, {
      key: "cell(actions)",
      fn: function (row) {
        return [_c("b-button", {
          staticClass: "mr-2",
          attrs: {
            size: "sm",
            variant: "danger"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return _vm.deleteItem(row.item);
            }
          }
        }, [_c("i", {
          staticClass: "fas fa-trash-alt"
        })])];
      }
    }], null, false, 1853217969)
  })], 1)], 1) : _c("div", [_c("b-card", {
    staticClass: "h-100 d-flex flex-column"
  }, [_c("h5", {
    staticClass: "mb-3"
  }, [_vm._v("Détails de l'article")]), _vm._v(" "), _c("b-form", {
    on: {
      submit: function ($event) {
        $event.preventDefault();
        return _vm.updateSelectedItem.apply(null, arguments);
      }
    }
  }, [_c("b-form-group", {
    attrs: {
      label: "Nom",
      "label-cols": "3"
    }
  }, [_c("b-form-input", {
    attrs: {
      required: ""
    },
    model: {
      value: _vm.selectedItemCopy.item_name,
      callback: function ($$v) {
        _vm.$set(_vm.selectedItemCopy, "item_name", $$v);
      },
      expression: "selectedItemCopy.item_name"
    }
  })], 1), _vm._v(" "), _c("b-form-group", {
    attrs: {
      label: "Catégorie",
      "label-cols": "3"
    }
  }, [_c("v-select", {
    attrs: {
      options: _vm.categories,
      taggable: "",
      placeholder: "Sélectionner ou ajouter une catégorie"
    },
    model: {
      value: _vm.selectedItemCopy.item_cat,
      callback: function ($$v) {
        _vm.$set(_vm.selectedItemCopy, "item_cat", $$v);
      },
      expression: "selectedItemCopy.item_cat"
    }
  })], 1), _vm._v(" "), _c("b-form-group", {
    attrs: {
      label: "Prix",
      "label-cols": "3"
    }
  }, [_c("b-form-input", {
    attrs: {
      type: "number",
      step: "0.01",
      required: ""
    },
    model: {
      value: _vm.selectedItemCopy.item_price,
      callback: function ($$v) {
        _vm.$set(_vm.selectedItemCopy, "item_price", _vm._n($$v));
      },
      expression: "selectedItemCopy.item_price"
    }
  })], 1), _vm._v(" "), _c("b-form-group", {
    attrs: {
      label: "Image",
      "label-cols": "3"
    }
  }, [_c("div", {
    staticClass: "mb-2"
  }, [_vm.selectedItemPreviewImage ? _c("img", {
    staticClass: "d-block mb-2 border rounded",
    staticStyle: {
      "max-width": "150px",
      "max-height": "150px"
    },
    attrs: {
      src: _vm.selectedItemPreviewImage,
      alt: "Preview Image"
    }
  }) : _vm.selectedItemImage ? _c("img", {
    staticClass: "d-block mb-2 border rounded",
    staticStyle: {
      "max-width": "150px",
      "max-height": "150px"
    },
    attrs: {
      src: _vm.selectedItemImage,
      alt: "Item Image"
    }
  }) : _vm._e()]), _vm._v(" "), _c("b-form-file", {
    attrs: {
      accept: "image/*"
    },
    on: {
      change: _vm.onDetailImageSelected
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "mt-3 d-flex justify-content-between"
  }, [_c("div", [_c("b-button", {
    attrs: {
      variant: "danger"
    },
    on: {
      click: _vm.deleteSelectedItem
    }
  }, [_c("i", {
    staticClass: "fas fa-trash-alt"
  }), _vm._v(" Supprimer\n              ")])], 1), _vm._v(" "), _c("div", [_c("b-button", {
    staticClass: "mr-2",
    attrs: {
      variant: "success",
      type: "submit"
    }
  }, [_vm._v("Modifier")]), _vm._v(" "), _c("b-button", {
    attrs: {
      variant: "secondary"
    },
    on: {
      click: _vm.resetSelection
    }
  }, [_vm._v("Annuler")])], 1)])], 1)], 1)], 1)]), _vm._v(" "), _c("b-modal", {
    attrs: {
      id: _vm.modalId,
      title: "Ajouter un article",
      "hide-footer": ""
    },
    on: {
      hide: _vm.resetModal
    }
  }, [_c("b-container", {
    attrs: {
      fluid: ""
    }
  }, [_c("b-form", {
    on: {
      submit: function ($event) {
        $event.preventDefault();
        return _vm.addNewItem.apply(null, arguments);
      }
    }
  }, [_c("b-form-group", {
    attrs: {
      label: "Nom",
      "label-cols": "3"
    }
  }, [_c("b-form-input", {
    attrs: {
      required: "",
      placeholder: "Nom de l'article"
    },
    model: {
      value: _vm.modalItem.item_name,
      callback: function ($$v) {
        _vm.$set(_vm.modalItem, "item_name", $$v);
      },
      expression: "modalItem.item_name"
    }
  })], 1), _vm._v(" "), _c("b-form-group", {
    attrs: {
      label: "Catégorie",
      "label-cols": "3"
    }
  }, [_c("v-select", {
    attrs: {
      options: _vm.categories,
      taggable: "",
      placeholder: "Sélectionner ou ajouter une catégorie"
    },
    model: {
      value: _vm.modalItem.item_cat,
      callback: function ($$v) {
        _vm.$set(_vm.modalItem, "item_cat", $$v);
      },
      expression: "modalItem.item_cat"
    }
  })], 1), _vm._v(" "), _c("b-form-group", {
    attrs: {
      label: "Prix",
      "label-cols": "3"
    }
  }, [_c("b-form-input", {
    attrs: {
      type: "number",
      step: "0.01",
      required: ""
    },
    model: {
      value: _vm.modalItem.item_price,
      callback: function ($$v) {
        _vm.$set(_vm.modalItem, "item_price", _vm._n($$v));
      },
      expression: "modalItem.item_price"
    }
  })], 1), _vm._v(" "), _c("b-form-group", {
    attrs: {
      label: "Image",
      "label-cols": "3"
    }
  }, [_c("b-form-file", {
    attrs: {
      accept: "image/*"
    },
    on: {
      change: _vm.onModalImageSelected
    }
  }), _vm._v(" "), _vm.modalPreviewImage ? _c("div", {
    staticClass: "mt-2"
  }, [_c("img", {
    staticStyle: {
      "max-width": "100px",
      "max-height": "100px"
    },
    attrs: {
      src: _vm.modalPreviewImage,
      alt: "Preview"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c("div", {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c("b-button", {
    attrs: {
      variant: "success",
      type: "submit"
    }
  }, [_c("i", {
    staticClass: "fas fa-check"
  }), _vm._v(" Ajouter\n          ")])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };